import { OfferModel } from '../../../../offer/model/OfferModel';

const IGNORED_DECLINE_REASONS = ['.', 'n/a'];

export const hasMeaningfulDeclineReason = (offer: OfferModel): boolean => {
    const cancelReason = offer.cancelReason?.trim().toLowerCase();

    return !!cancelReason && !IGNORED_DECLINE_REASONS.includes(cancelReason);
};
